module.exports = __webpack_public_path__ + "img/biaoji.445175a0.png";